export default "__VITE_ASSET__dc1043fe__"